import { useEffect, useRef } from 'react';
import _ from 'lodash';
import { useForm } from 'react-hook-form';
import { InputV2, SimpleDialog, AutocompleteV , InputCurrency } from 'components';
import { Grid, Button } from '@mui/material';
import { useProductsList } from 'hooks';
import { useStylesAddProductDialog } from './Style';
import useCustomHook from '../../hooks';

export default function AddProduct({
  isOpen,
  setIsOpen,
  selectedProducts,
  setSelectedProducts,
  defaultValues,
  tableRef,
  editMode = false,
}) {
  const { productSearchText, setProductSearchText } = useCustomHook();
  const { productsList, getProductsList, productsLoading } = useProductsList();
  const methods = useForm(editMode && { ...defaultValues, product: defaultValues?.id || null });
  const classes = useStylesAddProductDialog();
  const onAdd = () => {
    const data = methods.getValues();
    const val = {
      ...data,
      id: editMode ? defaultValues.id : data.product?.value,
      name: editMode ? defaultValues.name : data.product?.name,
    };

    setSelectedProducts((state) =>
      !editMode ? [...state, val] : state.map?.((p) => (p.id === val.id ? val : p)),
    );
    setTimeout(() => {
      tableRef?.current?.onChangeTable();
    }, 100)
    setIsOpen(false);
  };
  useEffect(() => {
    delayedQuery(productSearchText, getProductsList);
  }, [productSearchText]);

  useEffect(() => {
    methods.register('product');
    methods.register('price');
    methods.register('quantity');
    methods.register('discount');
    return () => {
      methods.unregister('product');
      methods.unregister('price');
      methods.unregister('quantity');
      methods.unregister('discount');
    };
  }, [methods.register, methods.unregister]);

  const delayedQuery = useRef(_.debounce((v, f) => f(v), 500)).current;
  return (
    <SimpleDialog open={isOpen} onClose={() => setIsOpen(false)} title="افزودن بند به فاکتور">
      <form noValidate autoComplete="off">
        <Grid container>
          <Grid item xs={12}>
            {editMode ? (
              <div>
                محصول:‌ {defaultValues.name} - {defaultValues.id}
              </div>
            ) : (
              <AutocompleteV
                placeholder="جستجو و انتخاب کنید..."
                control={methods.control}
                filterOptions={(options, state) => options}
                errors={methods.formState.errors}
                register={methods.register}
                rules={['required']}
                name="product"
                label="محصول"
                list={productsList}
                preventAddCustomOption
                loading={productsLoading}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionDisabled={(option) =>
                  selectedProducts.find((v) => v?.id === option?.id) != null
                }
                onInputChange={(e) => {
                  if (e?.target?.value === productSearchText) return;
                  setProductSearchText(e?.target?.value ?? '');
                }}
                disableClearable
                defaultValue={
                  defaultValues?.id
                    ? {
                      value: defaultValues?.id,
                      name: defaultValues?.name,
                      label: `${defaultValues?.name} - ${defaultValues?.id}`,
                    }
                    : null
                }
              />
            )}
            {methods.formState.errors.product && (
              <span className={classes.errorMessage}>{methods.formState.errors.product?.message}</span>
            )}
          </Grid>
          <Grid item xs={12}>
            <InputCurrency
              name="price"
              label="قیمت"
              errors={methods.formState.errors}
              register={methods.register}
              rules={['required', 'isInt', 'isMin|0']}
              control={methods.control}
              minimumValue={0}
              defaultValue={defaultValues?.price}
            />
          </Grid>
          <Grid item xs={12}>
            <InputV2
              name="quantity"
              label="تعداد"
              errors={methods.formState.errors}
              register={methods.register}
              rules={['required', 'isInt', 'isMin|0']}
              control={methods.control}
              minimumValue={0}
              currency
              currencyText="عدد"
              defaultValue={defaultValues?.quantity}
            />
          </Grid>
          <Grid item xs={12}>
            <InputV2
              name="description"
              errors={methods.formState.errors}
              register={methods.register}
              rules={['required']}
              control={methods.control}
              multiline
              rows={3}
              rowsMax={10}
              defaultValue={defaultValues?.description}
            />
          </Grid>
          <Grid item xs={12}>
            <InputCurrency
              name="discount"
              label="تخفیف"
              errors={methods.formState.errors}
              register={methods.register}
              rules={[
                'required',
                'isInt',
                'isMin|0',
                methods.watch('price') ? `isMax|${methods.watch('price')}` : 'required',
              ]}
              control={methods.control}
              minimumValue={0}
              defaultValue={defaultValues?.discount}
            />
          </Grid>
          <Grid xs={12} style={{display: 'flex', flexDirection: 'row-reverse', marginTop: '16px' ,  gap: '15px', }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                if (!methods.getValues().product?.value && !editMode)
                  methods.setError('product', { message: 'فیلد محصول اجباری است' });
                methods.handleSubmit(onAdd)();
              }}
            >
              {editMode ? 'ویرایش' : 'افزودن'}
            </Button>
          </Grid>
        </Grid>
      </form>
    </SimpleDialog>
  );
}
